import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { delay, finalize, Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { AuthenticationService } from '../_services/authentication.service';
import { GeneralService } from '../_services/general.service';
import { PublicApiKeyService } from '../_services/public-api-key.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  methodForLoading = ['PUT', 'PATCH', 'POST', 'DELETE'];
  constructor(
    private authenticationService: AuthenticationService,
    private generalService: GeneralService,
    private publicApiKeyService: PublicApiKeyService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Check if we're using public API key (don't add JWT in that case)
    const hasPublicApiKey = this.publicApiKeyService.hasApiKey();
    const isPublicRoute = window.location.hash.includes('/public/');
    
    console.log('[JwtInterceptor] Request URL:', request.url);
    console.log('[JwtInterceptor] Has public API key:', hasPublicApiKey);
    console.log('[JwtInterceptor] Is public route:', isPublicRoute);
    
    // Set loader to visible
    this.authenticationService.setLoading(true);
    if (this.methodForLoading.includes(request.method)) {
      // console.log(request.method);
      this.generalService.setBtnLoader(true);
    }

    const currentUser = this.authenticationService.currentUserValue;
    const isLoggedIn = currentUser && currentUser.token;
    const isApiUrl = request.url.startsWith(environment.apiPrefix);
    console.log('[JwtInterceptor] Is logged in:', isLoggedIn);
    console.log('[JwtInterceptor] Is API URL:', isApiUrl);
    if (isLoggedIn && isApiUrl) {
      console.log('[JwtInterceptor] Adding Authorization header');
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.token}`,
        },
      });
    } else {
      console.log('[JwtInterceptor] NOT adding Authorization header');
    }

    return next.handle(request).pipe(
      delay(0),
      finalize(() => {
        this.authenticationService.setLoading(false);
        this.generalService.setBtnLoader(false);
      })
    );
  }
}
